import TurnoverStatisticsChart from './Chart';

export default TurnoverStatisticsChart;
